import { faCircle } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Image, Space, Table, Tooltip, Typography } from 'antd';
import { ColumnsType } from 'antd/es/table';
import Link from 'antd/es/typography/Link';
import IcMoveTicket from '../../../assets/images/diagram/icon-drop.svg';
import icEdit from '../../../assets/images/ic-edit.svg';
import { formattedPrice, imageStatusTicket } from '../../../lib/utils';
import { useAppDispatch, useAppSelector } from '../../../redux/hooks';
import {
  getAvailableSeat,
  setDataMoveTicket,
  setIsMoveTicketWaiting,
} from '../../../redux/slice/bookings/moveTicketSlice';
import { USER_GROUP } from '../../../config/constant';
import { selectAuth } from '../../../redux/slice/authSlice';
import { useState } from 'react';

function ListCustomerNoDiagram({ listWaitingBooking, searchDateBooking }: any) {
  const { isMoveTicket } = useAppSelector((state) => state.moveTicket);
  const { group } = useAppSelector(selectAuth);
  const dispatch = useAppDispatch();
  const [activeRow, setActiveRow] = useState<number | null>(null);

  const onFieldDetail = (record: any) => {};

  const onMoveTicket = (record: any) => {
    dispatch(setIsMoveTicketWaiting(true));
    setActiveRow(record?.ticket_code);
    const dataSearchValue = {
      old_ticket_codes: record?.ticket_code,
      depart_date: searchDateBooking,
      segment_id: record?.segment_id,
      is_move_waiting: true,
      group_seat: record?.group_seat ? record?.group_seat : undefined,
    };
    dispatch(
      setDataMoveTicket({
        ticket_code: record?.ticket_code,
        segment_id: record?.segment_id,
        depart_date: searchDateBooking,
        pickup_location_id: record?.pickup_location?.id ?? undefined,
        drop_off_location_id: record?.drop_off_location?.id ?? undefined,
        pickup_extra: record?.pickup_extra ?? undefined,
        drop_off_extra: record?.drop_off_extra ?? undefined,
      }),
    );
    dispatch(getAvailableSeat(dataSearchValue));
    if (isMoveTicket) {
      dispatch(setIsMoveTicketWaiting(false));
    }
  };

  const columns1: ColumnsType<any> = [
    {
      title: 'Mã vé',
      dataIndex: '',
      key: 'ticket_code',
      width: '160px',
      render: (text, record) => (
        <Space size="small">
          <img src={imageStatusTicket(record)} alt="" />
          <Typography>{record?.ticket_code}</Typography>
        </Space>
      ),
    },
    {
      title: 'Hành khách',
      dataIndex: 'customer_name',
      key: 'customer_name',
      width: '180px',
      render: (text, record) => (
        <div>
          <Typography>{record?.customer_name}</Typography>
          <Typography>
            {' '}
            {record?.status === 'reserve' && record?.source === 'openapi' ? 'N/A' : record?.customer_phone}
          </Typography>
        </div>
      ),
    },
    {
      title: 'Đón tại',
      dataIndex: '',
      key: 'pickup_location',
      width: '210px',
      render: (record) => (
        <div>
          <Typography>
            {record?.pickup_extra ? record?.pickup_extra : record?.pickup_location?.location_name}
          </Typography>
          <Typography className="fs-14 fw-500">
            {record?.pickup_extra ? '' : record?.pickup_location?.address}
          </Typography>
        </div>
      ),
    },
    {
      title: 'Trả tại',
      dataIndex: '',
      key: 'drop_off_location',
      width: '210px',
      render: (record) => (
        <div>
          <Typography>
            {record?.drop_off_extra ? record?.drop_off_extra : record?.drop_off_location?.location_name}
          </Typography>
          <Typography className="fs-14 fw-500">
            {record?.drop_off_extra ? '' : record?.drop_off_location?.address}
          </Typography>
        </div>
      ),
    },
    {
      title: 'Nguồn vé',
      dataIndex: '',
      key: 'source',
      width: '130px',
      render: (record: any) => <Typography>{record?.orderer?.name}</Typography>,
    },
    {
      title: 'Thực thu',
      dataIndex: 'final_price',
      key: 'final_price',
      width: '130px',
      render: (text) => <Typography>{formattedPrice(text)}</Typography>,
    },
    {
      title: 'Phải thu',
      dataIndex: 'receivable',
      key: 'receivable',
      width: '130px',
      render: (text) => <Typography>{formattedPrice(text)}</Typography>,
    },
    group !== USER_GROUP.AGENT
      ? {
          title: '',
          dataIndex: 'action',
          key: 'action',
          render: (_, record: any) => (
            <Space size="middle">
              <Tooltip title="Xếp chỗ">
                <Link
                  onClick={() => {
                    onMoveTicket(record);
                  }}
                >
                  <Image width={17} height={17} className="icon-edit mr-20" src={IcMoveTicket} preview={false} />
                </Link>
              </Tooltip>
            </Space>
          ),
          align: 'center',
          width: '110px',
        }
      : {},
  ];
  return (
    <div className="mt-4">
      <h3 className="fw-600 fs-16 text-black"> Danh sách hành khách không sơ đồ ({listWaitingBooking?.length ?? 0})</h3>
      <Table
        locale={{
          triggerDesc: 'Sắp xếp giảm dần',
          triggerAsc: 'Sắp xếp tăng dần',
          cancelSort: 'Hủy sắp xếp',
        }}
        dataSource={listWaitingBooking?.length ? listWaitingBooking : []}
        rowKey="id"
        columns={columns1}
        className="list-bus table-waiting-list"
        pagination={false}
        rowClassName={(record) => (isMoveTicket && activeRow === record?.ticket_code ? 'ticket-move' : '')}
        rowHoverable={false}
      />
    </div>
  );
}

export default ListCustomerNoDiagram;
